module.exports = __webpack_public_path__ + "static/img/2.0158bcd1.jpg";